import {CreditCardForm as Validator} from '../../utils/validators';
import * as _ from "lodash";

interface Action {
    payload: any,
    type: string,
    field: string,
    apiError: boolean | string,
    value?: {length?: number },
    validate: boolean
}

interface Form {
    valid: boolean,
    changed: boolean
    apiError: boolean | string
    data: {
        [key: string]: {
            cardType?: any,
            required: boolean,
            added: boolean,
            value: any,
            min?: number,
            error: any,
            dirty?: boolean
        },
    }
}


const initialState: Form = {
    valid: false,
    changed: false,
    apiError: false,
    data: {
        number: {
            required: true,
            cardType: null,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        exp_month: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        exp_year: {
            required: true,
            added: false,
            value: null,
            min: 4,
            error: null,
            dirty: false
        },
        cvc: {
            required: true,
            added: false,
            value: null,
            min: 2,
            error: null,
            dirty: false
        },
        postal_code: {
            required: true,
            added: false,
            value: null,
            min: 5,
            error: null,
            dirty: false
        },
        paymentMethod: {
            required: false,
            added: false,
            value: null,
            error: null
        }
    },
};

export const SET_CARD_ERROR = 'SET_CARD_ERROR';

const baseState = _.cloneDeep(initialState);

const CreditCardForm = (state = initialState, action: Action) => {
    switch (action.type) {
        case 'CREDIT_CARD_FORM_ADD_CHANGE':
            return Validator({...state.data}, action);
        case "RESET_CREDIT_CARD":
            return _.cloneDeep(baseState);
        case "CARD_API_ERROR":
            const copy = {...state};
            const errorData = action.payload?.data;
            // 400_26 is a declined card and carries Stripe's reason. Other refusals are
            // shown too, or the submit would just stop with nothing on screen.
            if (errorData?.error_id === '400_26' && errorData?.message) {
                copy.apiError = errorData.message;
            } else if (action.payload?.code >= 400 && action.payload?.code < 500 && errorData?.message) {
                copy.apiError = errorData.message;
            } else {
                copy.apiError = 'We could not submit your request. Please try again.';
            }
            return copy;
        case SET_CARD_ERROR:
            const newState = {...state},
            errType = action.payload.errType;
            newState.data[errType].error = action.payload.message;
            newState.valid = false;
            return newState;
        default:
            return state;
    }
};

export default CreditCardForm;
